import React from 'react';
import { Button, FlexBox, Icon, Section, TextArea, tokensRaw } from '@vp/swan';
import { DrawerFooter } from '@99designs/design-services-layouts';
import { __ } from '@99designs/i18n';

export interface DrawerGeneralCommentFormProps {
    generalComment: string | undefined;
    handleCloseCommentForm: () => void;
    handleUpdateToRevisionRequest: (data: { comment?: string }) => void;
}

export const DrawerGeneralCommentForm: React.FC<DrawerGeneralCommentFormProps> = ({
    generalComment,
    handleCloseCommentForm,
    handleUpdateToRevisionRequest,
}) => {
    const [commentValue, setCommentValue] = React.useState<string | undefined>(generalComment);

    return (
        <>
            <Section padding="5">
                <TextArea
                    value={commentValue}
                    data-testid="general-comment"
                    onChange={(event) => setCommentValue(event.target.value)}
                    placeholder={__('Write a note to the designer')}
                    autoFocus={true}
                    rows={2}
                    fullWidth
                    style={{ fontSize: tokensRaw.SwanBaseFontSize100 }}
                />
            </Section>

            <DrawerFooter>
                <FlexBox justifyContent="flex-end" gap="3">
                    <Button
                        onClick={() => {
                            handleCloseCommentForm();
                            setCommentValue(generalComment);
                        }}
                        aria-label={__('Discard')}
                        skin="tertiary"
                    >
                        <Icon iconType="close" />
                    </Button>
                    <Button
                        onClick={() => {
                            handleCloseCommentForm();

                            if (commentValue !== generalComment) {
                                handleUpdateToRevisionRequest({ comment: commentValue });
                            }
                        }}
                        skin="primary"
                    >
                        {__('Save')}
                    </Button>
                </FlexBox>
            </DrawerFooter>
        </>
    );
};
